import { Grid } from '@mui/material';
import { styled } from '@mui/system';
import { Dispatch, SetStateAction } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IConsultant, updateBulkConsultants } from 'wisestep-api';
import {
  Item,
  Label,
  WsButton,
  WsButtonGroup,
  WsDialog,
  WsSelect,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

export const StyledItem = styled(Item)({
  display: 'flex',
  alignItems: 'center',
  width: '80%',
});
export const StyledLabel = styled(Label)({
  fontWeight: 'bold',
  width: '90%',
});

interface BulkUpdateProps {
  selectedConsultants: IConsultant[];
  onClose: Dispatch<SetStateAction<boolean>>;
  openBulkUpdate: boolean;
}

const BulkUpdate = ({ selectedConsultants, onClose, openBulkUpdate }: BulkUpdateProps) => {
  const methods = useForm({
    defaultValues: {
      status: '',
      availability: '',
      visibility: '',
      internalVisibility: '',
    },
  });
  const status = [
    {
      label: 'Prospect',
      value: 'New',
    },
    {
      label: 'Active',
      value: 'Active',
    },
    {
      label: 'Inactive',
      value: 'Inactive',
    },
  ];
  const availability = [
    {
      label: 'Not Available',
      value: 'NotAvailable',
    },
    {
      label: 'Available Immediately',
      value: 'AvailableImmediately',
    },
    {
      label: 'Available In 15 Days',
      value: 'AvailableIn15Days',
    },
    {
      label: 'Available In 30 Days',
      value: 'AvailableIn30Days',
    },
  ];

  const visibility = (index: number, value: string) =>
    methods.setValue('visibility', value.toLocaleLowerCase() == 'no' ? 'MyWorkspace' : 'Public');

  const onSave = (data) => {
    Object.keys(data).forEach((key) => (data[key] === undefined ? delete data[key] : {}));

    const updateConsultants = async () =>
      await updateBulkConsultants(
        selectedConsultants.map((consultant) => ({ ...consultant, ...data }))
      );

    updateConsultants();
    onClose(false);
  };

  return (
    <WsDialog openDialog={openBulkUpdate} size="medium">
      <Grid container p={4}>
        <Grid item xs={12} display="flex" justifyContent="space-between">
          <WsTypography variant={WsTypoVariants.TITLE}>Bulk Update - Consultants</WsTypography>
          <WsButton onClick={methods.handleSubmit(onSave)} type="submit">
            Save
          </WsButton>
        </Grid>
        <FormProvider {...methods}>
          <Grid item container xs={12} direction="column">
            <StyledItem>
              <StyledLabel>Status</StyledLabel>
              <WsSelect name="status" selectArray={status} size="small" />
            </StyledItem>
            <StyledItem>
              <StyledLabel>Availability</StyledLabel>
              <WsSelect name="availability" selectArray={availability} size="small" />
            </StyledItem>
            <StyledItem>
              <StyledLabel>Access (Select who can see this Consultant)</StyledLabel>
              <WsSelect name="internalVisibility" selectArray={status} size="small" />
            </StyledItem>
            <StyledItem>
              <StyledLabel>Visible to Recruiters Network</StyledLabel>
              <WsButtonGroup
                buttonsList={['Yes', 'No']}
                selectedIndexValue={visibility}
                inputTitle=""
              />
            </StyledItem>
          </Grid>
        </FormProvider>
      </Grid>
    </WsDialog>
  );
};

export default BulkUpdate;
